import { NotificationTypes, VoyNotification } from "../services/types/vessel-notifications-services.types";
import { VesselNotificationsService } from "../services/vessel-notifications-service";
import { VesselFeedbackStatusBase } from "./vessel-feedback-status-model";

export type FeedbackBodyData = {
  rating: string;
  comments: string;
}

export enum VesselFeedbackStatusModelEvents {
  VesselFeedbackFetched = "vessel-feedback-fetched"
}

export class VesselFeedbackStatusModelImpl extends VesselFeedbackStatusBase {
  constructor() {
    super();
    
    this.getVesselFeedback = this.getVesselFeedback.bind(this);
  }

  async setVesselFeedback({rating, comments}: FeedbackBodyData): Promise<void> {
    const data = JSON.stringify({rating, comments})
    const payload = {
      category: "Voyage",
      type: "NPS",
      data: data
    }

    await VesselNotificationsService.submitFeedback(payload);
  }

  async getVesselFeedback() {
    const vesselFeedbacks = await VesselNotificationsService.fetchNotifications(NotificationTypes.NPS);

    // Check if the newest date is older than one month
    const showPopup = this._isNewestDateOlderThanOneMonth(vesselFeedbacks);
    this.dispatchEvent(new CustomEvent(VesselFeedbackStatusModelEvents.VesselFeedbackFetched, {detail: showPopup}));
  }

  private _isNewestDateOlderThanOneMonth(data: VoyNotification<NotificationTypes.NPS>[]) {
    if (data.length === 0) return true; // Assuming true for showing the popup if array is empty
    let newestDate = new Date(data[0].created_at); // Initialize with the first date

    // Iterate through the arrau to find the newest date
    data.forEach((item) => {
      const itemDate = new Date(item.created_at);
      if (itemDate > newestDate) {
        newestDate = itemDate;
      }
    });
    
    //get the current mounth
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1); // Set to one month ago

    return newestDate < oneMonthAgo; 
  }
}
